import { render, staticRenderFns } from "./TipoOrcamento.vue?vue&type=template&id=fea3aa70&lang=html&"
import script from "./TipoOrcamento.vue?vue&type=script&lang=js&"
export * from "./TipoOrcamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/tipo-orcamento/TipoOrcamento.vue
// module id = 1539
// module chunks = 28